import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { CompensationDto } from './compensation-dto.model';
import { CompanyDto } from './company-dto.model';
import { ProjectDto } from './project-dto.model';
import { TransactionStatus } from '../service-proxies';


export class CompensationApplicationDto implements ICompensationApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    compensationRequestDate!: Date;
    compensationType!: CompensationDto;
    fromDate!: Date;
    toDate!: Date;
    compensationReason!: string | undefined;
    compensationStatus!: TransactionStatus;
    compensationStatusType!: string | undefined;
    company!: CompanyDto;
    project!: ProjectDto;

    constructor(data?: ICompensationApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.compensationRequestDate = _data["compensationRequestDate"] ? new Date(_data["compensationRequestDate"].toString()) : <any>undefined;
            this.compensationType = _data["compensationType"] ? CompensationDto.fromJS(_data["compensationType"]) : <any>undefined;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.compensationReason = _data["compensationReason"];
            this.compensationStatus = _data["compensationStatus"];
            this.compensationStatusType = _data["compensationStatusType"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompensationApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompensationApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["compensationRequestDate"] = this.compensationRequestDate ? this.compensationRequestDate.toISOString() : <any>undefined;
        data["compensationType"] = this.compensationType ? this.compensationType.toJSON() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["compensationReason"] = this.compensationReason;
        data["compensationStatus"] = this.compensationStatus;
        data["compensationStatusType"] = this.compensationStatusType;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompensationApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    compensationRequestDate: Date;
    compensationType: CompensationDto;
    fromDate: Date;
    toDate: Date;
    compensationReason: string | undefined;
    compensationStatus: TransactionStatus;
    compensationStatusType: string | undefined;
    company: CompanyDto;
    project: ProjectDto;
}

